import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    note_page:''
  },
  getters: {
  },
  mutations: {
    change_notePage(state,data){
        state.note_page=data
    }
  },
  actions: {
  },
  modules: {
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js